import { Cart } from '../types/PricingCalculator';

export interface SharedConfig {
    eligibility: {
        isFree: boolean;
        rrdbRegistrationDateISO?: string;
    };
    strategy: {
        existingSmartphone: boolean;
    };
    selections: {
        screen?: string;
        printer?: string;
        scanner?: string;
        adapters?: string[];
    };
    termMonths?: 1 | 6 | 12 | 24;
    userCount: number;
}

export function encodeCartToUrl(cart: Cart): string {
    const config: SharedConfig = {
        eligibility: {
            isFree: cart.eligibility.isFree,
            rrdbRegistrationDateISO: cart.eligibility.rrdbRegistrationDateISO
        },
        strategy: {
            existingSmartphone: cart.strategy.existingSmartphone
        },
        selections: {
            screen: cart.selections.screen?.id,
            printer: cart.selections.printer?.id,
            scanner: cart.selections.scanner?.id,
            adapters: cart.selections.adapters?.map(adapter => adapter.id)
        },
        termMonths: cart.termMonths,
        userCount: cart.userCount
    };

    const encoded = btoa(JSON.stringify(config));
    return `${window.location.origin}/pricing-calculator?config=${encoded}`;
}

export function decodeUrlToCart(url: string): SharedConfig | null {
    try {
        const urlObj = new URL(url);
        const configParam = urlObj.searchParams.get('config');

        if (!configParam) return null;

        const decoded = JSON.parse(atob(configParam)) as SharedConfig;
        return decoded;
    } catch (error) {
        console.error('Error decoding URL config:', error);
        return null;
    }
}

export function generateWhatsAppShareLink(cart: Cart): string {
    const configUrl = encodeCartToUrl(cart);
    const message = `Hello, check out this POS system configuration I am interested in buying! 🚀\n\n${configUrl}`;
    return `https://wa.me/250793090500?text=${encodeURIComponent(message)}`;
}
